const QUOTE = { Pending: "warning", Draft: "default", "Under Review": "secondary", Sent: "info", Accepted: "success", Declined: "error", Rejected: "error" };
const PROJECT = {
    "Awaiting Authorization": "warning",
    Pending: "default",
    "Not Started": "default",
    Planning: "info",
    "In Progress": "success",
    Active: "success",
    Testing: "info",
    "Ready for Review": "secondary",
    Review: "secondary",
    Approved: "success",
    Completed: "default",
    "On Hold": "warning",
    Cancelled: "error",
};
const TASK = { Pending: "default", "In Progress": "success", Testing: "info", "Ready for Review": "secondary", Approved: "success", Completed: "primary", "On Hold": "warning", Cancelled: "error" };
const INVOICE = { Draft: "warning", Open: "info", Paid: "success", Overdue: "error", Cancelled: "default" };
const PRIORITY = { Highest: "error", High: "warning", Medium: "info", Low: "success", Lowest: "success" };
const PRIVACY = { Private: "error", Internal: "warning", Public: "info" };
const ACTIVE = { Active: "success", Paused: "warning", Inactive: "error" };
const BILLING = { Retainer: "info", Hourly: "success", "Fixed Price": "secondary", Internal: "warning", "Non Billable": "default", Parent: "default" };
const DEADLINE = { "Open Ended": "primary", "On Track": "success", Upcoming: "warning", Overdue: "error" };
const ACCOUNT = { Active: "success", "In Progress": "success", Completed: "default", Paused: "warning", Cancelled: "error" };
const API_KEY = { Active: "success", "Never used": "info", Idle: "warning", Expired: "default", Revoked: "error" };

const DOMAINS = { quote: QUOTE, project: PROJECT, task: TASK, invoice: INVOICE, priority: PRIORITY, privacy: PRIVACY, active: ACTIVE, billing: BILLING, deadline: DEADLINE, account: ACCOUNT, apiKey: API_KEY };

const ciGet = (obj, value) => {
    if (!obj || value == null) return undefined;
    if (obj[value] !== undefined) return obj[value];
    const target = String(value).toLowerCase();
    const key = Object.keys(obj).find((k) => k.toLowerCase() === target);
    return key ? obj[key] : undefined;
};

export const statusSeverity = (domain, value) => ciGet(DOMAINS[domain], value) || "default";

export const severityToColor = (theme, severity) => {
    const map = {
        primary: theme.palette.primary.main,
        secondary: theme.palette.secondary.main,
        error: theme.palette.error.main,
        warning: theme.palette.warning.main,
        info: theme.palette.info.main,
        success: theme.palette.success.main,
        default: theme.palette.text.disabled,
    };
    return map[severity] || map.default;
};

export const statusColor = (theme, domain, value) => {
    const fromTheme = ciGet(theme?.palette?.status?.[domain], value);
    if (fromTheme) return fromTheme;
    return severityToColor(theme, statusSeverity(domain, value));
};
